// extracted by mini-css-extract-plugin
export var disabled = "_2i-5";
export var fileName = "_2i-b";
export var filePreview = "_2i-4";
export var hoverFilter = "_2i-6";
export var imageButton = "_2i-3 _2i-6";
export var imageButtonContainer = "_2i-2";
export var input = "_2i-7";
export var removeButton = "_2i-0";
export var removeButtonFile = "_2i-1";
export var spinner = "_2i-9";
export var spinnerContainer = "_2i-8";
export var videoContainer = "_2i-a _2i-6";